exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".corp-exp-card[data-v-7755f2a8]{border-radius:6px}.corp-exp-title[data-v-7755f2a8]{align-items:center;border-bottom:1px solid #e5e7eb}.corp-exp-subtitle[data-v-7755f2a8]{color:#64748b;font-size:12px;font-weight:400;margin-top:2px}.readonly-cell[data-v-7755f2a8]{color:#0f172a;line-height:1.45;min-height:36px;padding:10px 12px;white-space:pre-line}", ""]);

// exports
